<template>
  <div class="setting__user">
    <div class="setting__user--roles">
      <span>Administrators</span>
      <p>Your admins manage different tasks and information for your entire company.</p>
    </div>

    <div v-show="pageLoading">
      <div>
        <PageLoader />
      </div>
    </div>

    <div class="setting__user--permission" v-show="!pageLoading">

      <div class="setting__user--permission-header">
        <div class="setting__user--permission-name">Name</div>
        <div class="setting__user--permission-permission">Role</div>
      </div>

      <div class="setting__user--permission-body">
        <div v-for="adminValue in admin" v-bind:key="adminValue.index">
          <div class="setting__user--permission-name">
            <p>{{ adminValue.user.firstname + " " + (adminValue.user.middlename ? adminValue.user.middlename : "") + " " + adminValue.user.lastname}} ({{adminValue.user.email}})</p>
          </div>
          <div class="setting__user--permission-permission">{{ adminValue.role_name }}</div>
          <div class="setting__user--permission-edit">
            <routerLink :to="'/edit-admin/' + adminValue.user.id">Update priviledges</routerLink>
          </div>
        </div>
      </div>
    </div>
    <div class="setting__user--add" v-show="!pageLoading">
      <routerLink to="/add-admin">
        <font-awesome-icon icon="plus-circle" />&nbsp;Add New Admin
      </routerLink>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";

export default {
  name: "UserManagement",
  components: {
    PageLoader
  },
  data() {
    return {
      admin: null,
      pageLoading: true
    };
  },
  created() {
    this.pageLoading = true;
    this.$http
      .get(types.ADMIN_API)
      .then(resp => {
        this.admin = resp.data.data.data;
        this.$store.state.allAdmins = [...this.admin];
        this.pageLoading = false;
      })
      .catch();
  }
};
</script>

<style lang="scss" scoped>
.setting__user--roles {
  padding-top: 50px;
  width: 40rem;

    @media (max-width: 768px) {
      width: 23rem;
    }

  > span {
    font-size: 1.458rem;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
  }

  > p {
    font-size: 1.042rem;
    margin-top: 1.042vw;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 2;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
  }
}

.setting__user--permission {
  width: 47.865vw;

    @media (max-width: 768px) {
      width: 23rem;
    }

  > h4 {
    margin-bottom: 30px;
    font-size: 1rem;

    color: #000000;
  }

  > .setting__user--permission-header {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    align-content: center;
    padding-bottom: 20px;

    > .setting__user--permission-name {
      width: 50%;
      padding-left: 10px;
      font-size: 1.042rem;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
    }

    > .setting__user--permission-permission {
      width: 25%;
      padding-left: 10px;
      font-size: 1.042rem;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
    }

    > .setting__user--permission-edit {
      width: 25%;
      padding-left: 10px;
      font-size: 1.042rem;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
    }
  }

  > .setting__user--permission-body {
    border-top: 5px solid #5099de;

    > div {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
      border-radius: 2px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      height: 50px;
      margin-bottom: 20px;

      .setting__user--permission-name {
        width: 50%;
        padding-left: 10px;

        > span {
          font-size: 0.938rem;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.22;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
          text-decoration: underline;
        }

        > p {
          font-size: 0.938rem;
          font-weight: 300;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.33;
          letter-spacing: normal;
          text-align: left;
          color: #707070;
          margin-top: 15px;
        }
      }

      .setting__user--permission-permission {
        width: 25%;
        padding-left: 10px;
        font-size: 0.938rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.22;
        letter-spacing: normal;
        text-align: left;
        color: #000000;

        > span {
          color: #5099de;
        }
      }

      .setting__user--permission-edit {
        width: 25%;
        padding-left: 10px;
        font-size: 0.833rem;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: 2.5;
        letter-spacing: normal;
        text-align: left;
        

        > a {
          text-decoration: none;
          color: #f17d6b;
        }
      }
    }
  }
}

.setting__user--add {
  font-size: 1rem;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.22;
  letter-spacing: normal;
  text-align: left;
  margin-top: 36px;
  margin-bottom: 100px;

  > a {
    color: #5099de;
    text-decoration: none;
  }
}
</style>
